<template>
  <div class="preview-page">
    <a href="#" class="reload-button" @click.prevent="reloadPage">&#x21bb;</a>

    <IntroBlock v-if="page.introData" key="intro" :data="page.introData" />
    <div class="main">
      <div class="wrapper wrapper--wide">
        <div :is="block.componentName" v-for="block in page.blocks" :key="block.id" :data="block"></div>
      </div>
      <FooterBlock v-if="page.footerData" key="footer" :data="page.footerData" />
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'
import IntroBlock from '@/components/IntroBlock'
import TextBlock from '@/components/TextBlock'
import HtmlBlock from '@/components/HtmlBlock'
import ImageBlock from '@/components/ImageBlock'
import VideoBlock from '@/components/VideoBlock'
import TwoColBlock from '@/components/TwoColBlock'
import FooterBlock from '@/components/FooterBlock'

export default {
  name: 'preview-page',
  updated () {
    updateMeta(this)
    generateCustomCSS(this)
  },
  data () {
    return {
      page: {
        title: '',
        name: '',
        description: '',
        url: '',
        socialImage: '',
        blocks: [],
        styles: {},
      },
    }
  },
  components: {
    IntroBlock,
    TextBlock,
    HtmlBlock,
    ImageBlock,
    VideoBlock,
    TwoColBlock,
    FooterBlock
  },
  methods: {
    reloadPage() {
      document.location.reload()
    }
  },
  firestore() {
    return {
      page: firestore.collection('pages').doc(this.$route.params.id)
    }
  }
}

function updateMeta(data) {
  document.title = data.page.title
  //document.head.querySelector('meta[name=description]').content = 'New Description'
}

function loadFont(data, value) {
  var index = _.findIndex(data.page.typefaces, { 'url': data.page.styles[value] })
  return index > -1 ? `font-family: "Font ${index}" !important;` : ''
}

function generateCustomCSS(data) {
  if (!data.page.styles) return

  var fonts = ''
  if (data.page.typefaces) {
    for(var i = 0; i < data.page.typefaces.length; i++) {
      fonts += `
      @font-face {
        font-family: "Font ${i}";
        src: url("${data.page.typefaces[i].url}") format("woff");
      }
      `
    }
  }

  var css = `
    ${fonts}
    .preview-page .main {
      background: ${data.page.styles.backgroundColour} !important;
    }
    .preview-page .fixed-opener figcaption {
      color: ${data.page.styles.intro_font_colour} !important;
      font-size: ${data.page.styles.intro_font_size};
      ${loadFont(data, 'intro_font')}
    }
    .preview-page .footer {
      color: ${data.page.styles.footer_font_colour} !important;
      font-size: ${data.page.styles.footer_font_size};
      ${loadFont(data, 'footer_font')}
    }
    .preview-page h3, .preview-page a, .preview-page .highlight {
      color: ${data.page.styles.highlightColour};
    }
    .preview-page h1 {
      color: ${data.page.styles.h1_colour};
      font-size: ${data.page.styles.h1_size};
      ${loadFont(data, 'h1_font')}
    }
    .preview-page h2 {
      color: ${data.page.styles.h2_colour};
      font-size: ${data.page.styles.h2_size};
      ${loadFont(data, 'h2_font')}
    }
    .preview-page h3 {
      color: ${data.page.styles.h3_colour};
      font-size: ${data.page.styles.h3_size};
      ${loadFont(data, 'h3_font')}
    }
    .preview-page blockquote {
      color: ${data.page.styles.blockquote_colour};
      font-size: ${data.page.styles.blockquote_size};
      ${loadFont(data, 'blockquote_font')}
    }
    .preview-page figcaption {
      color: ${data.page.styles.caption_colour};
      font-size: ${data.page.styles.caption_size};
      ${loadFont(data, 'caption_font')}
    }
    .preview-page,
    .preview-page .text,
    .preview-page form input,
    .preview-page form select,
    .preview-page form label {
      font-size: ${data.page.styles.default_font_size};
      ${loadFont(data, 'default_font')}
    }
    .preview-page form input[type=submit] {
      background: ${data.page.styles.highlightColour};
      border: 0;
      color: ${data.page.styles.backgroundColour};
    }
  `

  var style = document.querySelector('#override-css')
  if (!style) {
    style = document.createElement('style')
    style.type = 'text/css'
    style.id = 'override-css'
    document.head.appendChild(style)
  }
  style.innerHTML = css
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../static/css/style.css';
  .reload-button {
    background: orange;
    color: black !important;
    text-decoration: none;
    padding: 0.3em 0.3rem 0em;
    line-height: 1;
    position: fixed;
    right: 0.25rem;
    top: 0.25rem;
    display: block;
    z-index: 999;
    font-size: 1.25rem;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Preview-Page.vue